import { useAssetLogo } from '@interxfi/api-client/asset/use-asset-logo';
import { useIxcAssetsV1AssetQueryServiceAssetGet } from '@interxfi/api-client/generated/hooks/ixc-assets-v1-asset-query-service-asset-get';
import { AssetLogo } from '@interxfi/app-components/components/asset-logo/asset-logo';
import { getAssetDisplayName } from '../utils';

interface AssetLogoBreadcrumbProps {
  assetId: string;
}

export function AssetLogoBreadcrumb({ assetId }: AssetLogoBreadcrumbProps) {
  const { logoSrc, hasLogo } = useAssetLogo(assetId);
  const { data } = useIxcAssetsV1AssetQueryServiceAssetGet({ assetId });
  const name = getAssetDisplayName(data?.asset?.data?.type);

  if (!hasLogo) {
    return null;
  }

  return <AssetLogo alt={name ? `${name} Logo` : undefined} size="small" src={logoSrc} />;
}
